import { useNavigate } from "react-router-dom";
import {
  ROUTE_RENDERINGS,
  ROUTE_DASHBOARD,
  RouteType,
} from "@constants/routes";

interface Overview {
  totalRenderingCount: string;
  totalTemplateCount: string;
  monthlyRenderingCount: string;
  templateLimit: number;
  monthlyRenderingLimit: number;
}

type keys = keyof Overview;

const stats: {
  key: keys;
  name: string;
  navigateTo?: RouteType;
  limitKey?: keyof Overview;
}[] = [
  {
    key: "totalTemplateCount",
    name: "Templates",
    navigateTo: ROUTE_DASHBOARD,
    limitKey: "templateLimit",
  },
  {
    key: "totalRenderingCount",
    name: "Total Renderings",
    navigateTo: ROUTE_RENDERINGS,
  },
  {
    key: "monthlyRenderingCount",
    name: "Monthly Renderings",
    limitKey: "monthlyRenderingLimit",
  },
];

function getLimitDisplay(value: string, limit: number | undefined) {
  if (typeof limit === "number") {
    if (limit === Infinity) return `${value} / ∞`;
    if (limit > 0) return `${value} / ${limit}`;
  }
  return value;
}

export default function Stats({
  overview = {
    totalRenderingCount: "Loading ...",
    totalTemplateCount: "Loading ...",
    monthlyRenderingCount: "Loading ...",
    monthlyRenderingLimit: 0,
    templateLimit: 0,
  },
}: {
  overview: Overview;
}) {
  const navigate = useNavigate();

  return (
    <div>
      <dl className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {stats.map((item, index) => {
          const value = String(overview[item.key]);
          let limit = item.limitKey ? overview[item.limitKey] : undefined;
          limit = typeof limit === "number" ? limit : undefined;
          const display = getLimitDisplay(value, limit);
          return (
            <div
              key={index}
              className={`flex flex-col items-center justify-center rounded-2xl bg-white p-8 shadow-sm ring-1 ring-gray-200 transition hover:shadow-md ${
                item.navigateTo
                  ? "cursor-pointer hover:ring-2 hover:ring-gray-300"
                  : ""
              } min-h-[140px]`}
              onClick={() => {
                if (item.navigateTo) {
                  navigate(item.navigateTo);
                }
              }}
            >
              <span className="text-3xl font-extrabold text-gray-900">
                {display}
              </span>
              <span className="mt-2 text-base font-medium text-gray-600">
                {item.name}
              </span>
            </div>
          );
        })}
      </dl>
    </div>
  );
}
